"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileBlub = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const avatar_1 = require("../avatar");
const theme_1 = __importDefault(require("../../styles/theme"));
const button_1 = __importDefault(require("../buttons/button"));
const app_text_1 = __importDefault(require("../typography/app_text"));
const icons_1 = require("../icons");
const layout_1 = require("../layout");
const ProfileBlub = ({ avatarUrl, email, name, workspace, canSwitchWorkspace = false, onEditProfile, onLogOut = () => { }, centralLoginUrl, statusColor, statusText, onSwitchWorkspaces = () => { }, onOpenDeviceSettings = () => { }, closeBlub = () => { }, onOpenSystemNotifications = () => { }, }) => {
    return ((0, jsx_runtime_1.jsxs)(ProfileBlubWrapper, Object.assign({ workspaceImageUrl: workspace === null || workspace === void 0 ? void 0 : workspace.imageUrl }, { children: [(0, jsx_runtime_1.jsxs)(layout_1.Flex, Object.assign({ alignItems: "center", style: {
                    paddingLeft: '16px',
                    marginBottom: '12px',
                } }, { children: [(0, jsx_runtime_1.jsx)(avatar_1.Avatar, { src: avatarUrl, displayName: name, size: "small" }), (0, jsx_runtime_1.jsxs)(layout_1.Box, Object.assign({ marginLeft: "12px" }, { children: [(0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ as: "h3", semibold: true }, { children: name })), (0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ style: { fontSize: '14px' } }, { children: email })), statusColor && statusText && ((0, jsx_runtime_1.jsxs)(StatusContainer, { children: [(0, jsx_runtime_1.jsx)(StatusIndicator, { color: statusColor, alignItems: "center", justifyContent: "center", borderRadius: 50 }), (0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ style: { color: theme_1.default.colors.grey40, fontSize: '14px' } }, { children: statusText }))] }))] }))] })), workspace && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "workspace__current-space-wrapper" }, { children: [(0, jsx_runtime_1.jsxs)(layout_1.Flex, Object.assign({ justifyContent: "space-between", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsxs)(layout_1.Flex, { children: [canSwitchWorkspace ? ((0, jsx_runtime_1.jsx)(icons_1.AppIcon, { className: "workspace__done-icon", name: 'DoneIcon', color: theme_1.default.colors.azure })) : ((0, jsx_runtime_1.jsx)("span", {})), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "workspace__text" }, { children: [(0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ as: "h4", color: "medium", style: { fontSize: '14px' }, semibold: true }, { children: "WORKSPACE" })), (0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ as: "h3", semibold: true }, { children: workspace.name })), (0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ style: { fontSize: '14px' }, as: 'p' }, { children: workspace.url }))] }))] }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "workspace__image" }, { children: !workspace.imageUrl && ((0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ as: "p", bold: true, size: "medium", color: "light" }, { children: workspace.name.charAt(0) }))) }))] })), canSwitchWorkspace && centralLoginUrl && ((0, jsx_runtime_1.jsx)(button_1.default, Object.assign({ onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            yield onSwitchWorkspaces();
                            window.location.assign(centralLoginUrl);
                        }), variant: "inline", style: {
                            marginTop: '16px',
                            marginBottom: '24px',
                        } }, { children: "Switch to another workspace" })))] }))), onEditProfile && ((0, jsx_runtime_1.jsx)(ProfileButton, Object.assign({ onClick: onEditProfile, "data-testid": "profile-popout-edit-profile", closeBlub: closeBlub }, { children: (0, jsx_runtime_1.jsx)(app_text_1.default, { children: "Edit Profile" }) }))), (0, jsx_runtime_1.jsx)(ProfileButton, Object.assign({ onClick: onOpenDeviceSettings, "data-testid": "profile-popout-device-settings", closeBlub: closeBlub }, { children: (0, jsx_runtime_1.jsx)(app_text_1.default, { children: "Device Settings" }) })), (0, jsx_runtime_1.jsx)(ProfileButton, Object.assign({ onClick: onOpenSystemNotifications, "data-testid": "profile-popout-system-notifications", closeBlub: closeBlub }, { children: (0, jsx_runtime_1.jsx)(app_text_1.default, { children: "System Notifications" }) })), (0, jsx_runtime_1.jsx)(ProfileButton, Object.assign({ onClick: onLogOut, "data-testid": "profile-popout-log-out-user", closeBlub: closeBlub }, { children: (0, jsx_runtime_1.jsx)(app_text_1.default, { children: "Log Out" }) }))] })));
};
exports.ProfileBlub = ProfileBlub;
const StatusContainer = styled_1.default.div({
    display: 'flex',
    alignItems: 'center',
});
const StatusIndicator = (0, styled_1.default)(layout_1.Flex)(({ color }) => ({
    zIndex: 1,
    height: '10px',
    width: '10px',
    background: color,
    marginRight: '8px',
}));
const ProfileBlubWrapper = styled_1.default.div(({ theme, workspaceImageUrl }) => ({
    position: 'relative',
    width: '360px',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: `24px`,
    backgroundColor: theme.colors.white,
    boxShadow: theme.shadow.xlarge,
    borderRadius: '10px',
    wordBreak: 'break-word',
    '.workspace__current-space-wrapper': {
        width: '100%',
        borderTop: `1px solid ${theme.colors.grey10}`,
        paddingTop: '16px',
        paddingLeft: '16px',
        paddingRight: '16px',
    },
    '.workspace__done-icon': {
        alignSelf: 'end',
        marginRight: '16px',
        marginBottom: '16px',
    },
    '.workspace__image': {
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundImage: `url(${workspaceImageUrl})`,
        backgroundColor: workspaceImageUrl ? theme.colors.white : theme.colors.darkGradientTop,
        height: '48px',
        width: '48px',
        border: `1px solid ${theme.colors.grey10}`,
        borderRadius: '10px',
        marginLeft: theme.spacing.s,
        marginRight: theme.spacing.s,
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    '.workspace__text': {
        '>*': {
            overflowWrap: 'anywhere',
            overflow: 'hidden',
            display: '-webkit-box',
        },
        '>*:nth-of-type(1)': {
            marginBottom: '2px',
        },
    },
}));
const StyledProfileButton = (0, styled_1.default)('button')(({ theme }) => ({
    border: 'none',
    borderTop: `1px solid ${theme.colors.grey10}`,
    padding: '16px',
    textAlign: 'left',
    backgroundColor: 'white',
    cursor: 'pointer',
    ':hover': {
        backgroundColor: theme.colors.blue05,
    },
    ':last-of-type': {
        borderBottomLeftRadius: '10px',
        borderBottomRightRadius: '10px',
    },
}));
const ProfileButton = (_a) => {
    var { closeBlub, onClick } = _a, props = __rest(_a, ["closeBlub", "onClick"]);
    const handleClick = (e) => {
        closeBlub();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (0, jsx_runtime_1.jsx)(StyledProfileButton, Object.assign({ onClick: handleClick }, props));
};
//# sourceMappingURL=profile_blub.js.map